<template>
  <!-- <v-container class="mt-5"> -->
<!--     <v-row justify="center">
      <h1>Ordina i prodotti del totem</h1>
    </v-row> -->
    <v-row justify="center">
      <v-col>
        <v-card
          v-for="(category, categoryIndex) in categorie"
          :key="categoryIndex"
          class="rounded-lg mx-1 mt-3"
        >
          <v-card-title class="text-h4 font-weight-bold">
            {{ category.name }}
          </v-card-title>
          <v-card-text>
            <v-row>
              <draggable
                v-model="categorie[categoryIndex].children"
                group="categories"
                @start="drag = true"
                @end="drag = false"
                style="display: flex;"
              >
                <div
                  v-for="(child, childIndex) in categorie[categoryIndex]
                    .children"
                  :key="childIndex"
                  :style="styleObject"
                  class="rounded-lg"
                >
                  <div class="text-h6 font-weight-bold">{{ child.name }}</div>

                  <!-- Nested draggable for grandchildren -->
                  <draggable
                    v-if="child.children"
                    v-model="
                      categorie[categoryIndex].children[childIndex].children
                    "
                    group="children"
                    :key="`child-${childIndex}`"
                    @start="drag = true"
                    @end="drag = false"
                    @change="log"
                  >
                    <transition-group
                      type="transition"
                      :name="!drag ? 'flip-list' : null"
                    >
                      <div
                        v-for="grandchild in child.children"
                        :key="grandchild.codice"
                        :style="childStyleObject"
                        class="rounded-lg d-flex align-center justify-center"
                      >
                        {{ grandchild.name }}
                      </div>
                    </transition-group>
                  </draggable>
                </div>
              </draggable>
            </v-row>
          </v-card-text>
        </v-card>
        <!-- Save Button -->
        <v-row class="ml-5 mt-4 mb-5">
          <v-btn color="success" dark @click="saveCategorie" :disabled="saving">
            {{ saving ? "Saving..." : "Salva" }}
          </v-btn>
        </v-row>
      </v-col>
    </v-row>
  <!-- </v-container> -->
</template>

<script>
/* eslint-disable */
// import configurazioni from "@/services/configurazioniService"
import draggable from "vuedraggable"

export default {
  name: "ordinaProdottiTotem",
  components: {
    draggable,
  },
  data() {
    return {
      prodotti: [],
      styleObject: {
        border: "1px solid black",
        borderColor: "black",
        padding: "10px",
        margin: "5px",
      },
      childStyleObject: {
        border: "1px solid black",
        borderColor: "black",
        padding: "10px",
        margin: "5px",
      },
      categorie: [],
      drag: false,
      saving: false // Track drag status
    }
  },
  props: {
    item: Object
  },
  watch: {
    item() {
      this.categorie = this.item.struttura
    }
  },
  mounted() {
    this.categorie = this.item.struttura
  },  
  methods: {
    log() {},
    saveCategorie() {
      this.$emit('aggiorna', this.item.codice, this.categorie)
/*       try {
        const prodottiTotem = await configurazioni.getConfigurazione(
          "totem",
          "totem"
        );
        this.saving = true;
        prodottiTotem[0].struttura = this.categorie;
        console.log(prodottiTotem);
        const result = await configurazioni.modificaConfigurazione({
          _id: "totem",
          totem: prodottiTotem
        });
        console.log("Configurazione salvata");
      } catch (error) {
        console.error("Error saving categorie:", error)
      } finally {
        this.saving = false
      } */
    }
  }
/*   async created() {
    try {
      const prodottiTotem = await configurazioni.getConfigurazione(
        "totem",
        "totem"
      );
      this.categorie = prodottiTotem[0].struttura;
    } catch (error) {
      console.error("Error fetching configurazioni:", error);
    }
  }, */
};
</script>
